
export const labelTemplatesRegister = {
  visitorLabelWithCompany: {
    title: "Default Label With Visitor Company",
    value: 1
  },
  visitorLabelWithoutCompany: {
    title: "Default Label Without Visitor Company",
    value: 2
  },
  visitorLabelWithVisitorCompany: {
    title: "Label With Visitor Company",
    value: 4
  },
  queueLabelWithNumbers: {
    title: "Label With Queue Number",
    value: 8
  },
  wartsilaGasVisitor: {
    title: "Wartsila Gas Company Visitor",
    value: 16
  },
  valmarineVisitor: {
    title: "Valmarine Visitor",
    value: 17
  },
  wartsilaValmarine: {
    title: "Wartsila Valmarine",
    value: 18
  },
  companiesAndLicensePlate: {
    title: "Companies And License Plate",
    value: 19
  }
};
